import { cn } from "@/lib/utils";

export function StatusBadge({ status }) {
  const map = {
    active: "bg-emerald-100 text-emerald-700 border-emerald-200",
    inactive: "bg-slate-100 text-slate-600 border-slate-200",
    pending: "bg-amber-100 text-amber-700 border-amber-200",
    approved: "bg-emerald-100 text-emerald-700 border-emerald-200",
    completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
    shipped: "bg-blue-100 text-blue-700 border-blue-200",
    processed: "bg-blue-100 text-blue-700 border-blue-200",
    in: "bg-sky-100 text-sky-700 border-sky-200",
    out: "bg-slate-100 text-slate-600 border-slate-200",
    low: "bg-red-100 text-red-700 border-red-200",
    ok: "bg-emerald-100 text-emerald-700 border-emerald-200",
    critical: "bg-red-100 text-red-700 border-red-200",
    warning: "bg-amber-100 text-amber-700 border-amber-200",
    info: "bg-sky-100 text-sky-700 border-sky-200",
  };
  const cls = map[(status || "").toLowerCase()] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span data-testid="status-badge" className={cn(
      "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize dark:bg-opacity-20",
      cls
    )}>
      {status || "—"}
    </span>
  );
}
